import styled from 'styled-components';

import * as NavMenuItem from '../../../NavMenuItem/styles';

export const NavLink = styled(NavMenuItem.NavLink)`
  padding: 4px 0;

  &:first-child {
    margin-top: 4px;
  }

  &:last-child {
    margin-bottom: 4px;
  }

  & + & {
    margin-top: 8px;
  }
`;
